export const getCurrentStatus = (id, typeOrderStatus, orders) => {
    let [order] = orders.filter(item => item.id === parseInt(id))
    //filtra los estados de ordenes troncales y los ordena para obtener el último
    let allStatus = order.orderstatus_set.filter(os => os.type_order_status_trunk).sort((a, b) => b.id - a.id)
    let currentOrderStatus = allStatus[0]
    let [currentType] = typeOrderStatus.filter(item => item.id === currentOrderStatus.type_order_status)
    return currentType
}